module.exports = __webpack_public_path__ + "img/160.6ddc76be.gif";